module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"heading":["App Users can only see and fill the Forms that they are explicity given access to in the table below. Project Managers and Data Collectors can use a web browser to fill out any Form in the Project that is in the Open state."],"emptyTable":"There are no Forms to show.","alert":{"success":"Your changes have been saved!"}}}')
  delete Component.options._Ctor
}
